<div class="support">
    <h1> Support</h1>
    <mat-list role="list">
        <mat-list-item role="listitem">Guide Vendeur</mat-list-item>
        <mat-list-item role="listitem">Guide Acheteur</mat-list-item>
        <mat-list-item role="listitem">Blog</mat-list-item>
        <mat-list-item role="listitem">Certification AfriAutos</mat-list-item>
        
    </mat-list>

    <router-outlet></router-outlet>
</div>


  